import useSWRV from "swrv";
import {computed} from "vue";
import {getDataFetcher, getSWRVOptions} from "@/functions/utils";

/**
 * Настройки сайта из админки (Сайт → Логотип / Главная страница).
 * Сначала показываем сохранённое в браузере, затем сразу подтягиваем свежее с сервера,
 * чтобы правки из админки появлялись при следующем открытии страницы.
 *
 * @param {'branding'|'home'|'general-design'} section
 * @returns {import('vue').ComputedRef<Object|null>}
 */
export function useSiteSettings(section) {
    const {data} = useSWRV(`/api/settings/${section}`, getDataFetcher(), {
        ...getSWRVOptions(),
        dedupingInterval: 2000,
    });
    return computed(() => data.value?.data ?? null);
}

/** Бренды для главной (Catalog → Manufacturers → «Показывать на главной»). */
export function useHomeBrands() {
    const {data} = useSWRV('/api/manufacturers/home', getDataFetcher(), {
        ...getSWRVOptions(),
        dedupingInterval: 2000,
    });
    return computed(() => (Array.isArray(data.value?.data) ? data.value.data : null));
}

/** Текст из админки, а если там пусто — запасной. */
export function textOr(value, fallback) {
    return typeof value === "string" && value.trim() !== "" ? value : fallback;
}

/** Список из админки, а если там пусто — запасной. */
export function listOr(value, fallback) {
    return Array.isArray(value) && value.length ? value : fallback;
}
